import type { RouteRecordRaw } from 'vue-router'
import { i18n } from '@/shared/i18n'

export const SupplierContractPages = {
  list: 'ListSupplierContract',
  add: 'AddSupplierContract',
  edit: 'EditSupplierContract',
}

const { t } = i18n.global

const title = t('pages.listSupplierContract')
const path = '/supplier-contracts'
const breadcrumb = [{ title, path }]

const Add: RouteRecordRaw = {
  path: 'add',
  name: SupplierContractPages.add,
  component: () =>
    import('@/pages/mainPageWithRoute/supplier-contract/AddSupplierContractPage.vue'),
  meta: { title: t('actions.add'), requiresAuth: true, breadcrumb },
}

const Edit: RouteRecordRaw = {
  path: ':id',
  name: SupplierContractPages.edit,
  component: () =>
    import('@/pages/mainPageWithRoute/supplier-contract/EditSupplierContractPage.vue'),
  meta: { title: t('actions.edit'), requiresAuth: true, breadcrumb },
}

const List: RouteRecordRaw = {
  path: '',
  name: SupplierContractPages.list,
  component: () =>
    import('@/pages/mainPageWithRoute/supplier-contract/ListSupplierContractPage.vue'),
  meta: { title, requiresAuth: true },
}

export const SupplierContracts: RouteRecordRaw = {
  path,
  name: 'SupplierContracts',
  component: () => import('@/pages/mainPageWithRoute/MainPageWithRouterView.vue'),
  meta: { title, requiresAuth: true },
  children: [List, Add, Edit],
}
